import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import moment from 'moment';

// Own constants/actions/components
import { getDetailExperienceAction } from 'services/actions/detail-experience';
import { getSessionAction } from 'services/actions/header';
import { results, resData } from 'services/selectors/detail-experience';
import ContactSection from 'components/contact-section';
import AccordionCollapse from 'components/accordion-collapse';
import LoaderCP from 'components/loader';
import CardStockComp from 'components/card-stock';
import NotFound from 'components/notFound';
import TypeHome from './type-home';
import TypeFaceToFace from './type-face-to-face';
import TypeTravel from './type-travel';
import TypeHomeMobile from './type-home-mobile';
import TypeFaceToFaceMobile from './type-face-to-face-mobile';
import TypeTravelMobile from './type-travel-mobile';

// Assets
import exhaustedIcon from '../../assets/exhausted.svg';
import TypeInPersonMobile from './type-in-person-mobile';
import TypeInPerson from './type-in-person';

const DetailExperienceContainer = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector(results);
  const result = useSelector(resData);
  const [date, setDate] = useState('');
  const [optionValue, setOptionValue] = useState('');
  const [openCollapse, setOpenCollapse] = useState(false);
  const [dataUser, setDataUser] = useState({});
  const [isFetching, setIsFetching] = useState(true);
  const cards = dataUser && dataUser.cards !== undefined ? dataUser.cards : [];

  const dateActual = () => {
    const todate = new Date();
    setDate(todate);
  };

  const handleOpenAddExperiencie = (flag) => {
    setOpenCollapse(flag);
  };

  useEffect(() => {
    dispatch(getDetailExperienceAction(id));
    dateActual();
  }, []);

  useEffect(async () => {
    const response = await dispatch(getSessionAction());
    const dataUserResponse = response.action.payload.data;

    setDataUser(dataUserResponse);
    setIsFetching(false);
  }, []);

  const renderBody = (detail) => {
    return (
      <div>
        {detail.type.constant === 'HOUSE' ? (
          <TypeHomeMobile
            details={detail}
            points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
            startDay={date}
            open={openCollapse}
            handleOpenExp={handleOpenAddExperiencie}
            setOptionValue={setOptionValue}
            optionValue={optionValue}
            cards={cards} />
        ) : ''}
        {detail.type.constant === 'MASTERCLASS' ? (
          <TypeFaceToFaceMobile
            details={detail}
            points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
            open={openCollapse}
            handleOpenExp={handleOpenAddExperiencie}
            optionValue={optionValue}
            cards={cards} />
        ) : ''}
        {detail.type.constant === 'FACE_TO_FACE' ? (
          <TypeFaceToFaceMobile
            details={detail}
            points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
            open={openCollapse}
            handleOpenExp={handleOpenAddExperiencie}
            optionValue={optionValue}
            cards={cards} />
        ) : ''}
        {detail.type.constant === 'IN_PERSON_SCHEDULED' ? (
          <TypeInPersonMobile
            details={detail}
            points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
            open={openCollapse}
            handleOpenExp={handleOpenAddExperiencie}
            optionValue={optionValue}
            setOptionValue={setOptionValue}
            cards={cards} />
        ) : ''}

        {detail.type.constant === 'TRAVEL' ? (
          <TypeTravelMobile
            details={detail}
            points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
            open={openCollapse}
            handleOpenExp={handleOpenAddExperiencie}
            cards={cards} />
        ) : ''}
        {detail.type.constant === 'TRAVEL_INTERNATIONAL' ? (
          <TypeTravelMobile
            details={detail}
            points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
            open={openCollapse}
            handleOpenExp={handleOpenAddExperiencie}
            cards={cards} />
        ) : ''}
        <Container fluid className="bg-white">
          <Container>
            <Row className="py-60">
              <Col lg={9} className="order-lg-1 order-2">
                <Row>
                  <Col lg={12}>
                    <h2 className="text-midnight-blue ft-28">{detail.title}</h2>
                  </Col>
                  <Col lg={12}>
                    <p className="py-15 text-tangaroa">
                      {detail.shortDescription}
                    </p>
                  </Col>
                  <Col className="d-block d-lg-none py-15">
                    {detail.stock !== null && detail.stock < 5 ? <CardStockComp /> : ''}
                  </Col>
                  {detail.location ? (
                    <Col md={12} lg={3}>
                      <i className="fas fa-map-marker-alt mr-2 text-dark-blue" />
                      <small className="text-dove-gray">{detail.location}</small>
                    </Col>
                  ) : ''}
                  <Col md={12} lg={2}>
                    <i className="fas fa-user-friends mr-2 text-dark-blue" />
                    <small className="text-dove-gray">{`x${detail.numberOfPeople}`}</small>
                  </Col>
                  <Col md={12} lg={3}>
                    <i className="fas fa-box-open mr-2 text-dark-blue" />
                    <small className="text-dove-gray">{detail.type.iconText}</small>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className="imgage-detail">
                      <img
                        src={detail.image}
                        alt="banner-detail"
                        className="py-15 w-100" />
                      {detail.stock === 0 && (
                        <div className="label">
                          <div>
                            <img
                              className="carousel-icon mr-2 ml-1"
                              src={exhaustedIcon}
                              alt="exhaustedIcon" />
                          </div>
                          <div className="text-icon">EXPERIENCIA AGOTADA</div>
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="text-tangaroa">
                      <ReactMarkdown>{detail.longDescription}</ReactMarkdown>
                    </div>
                  </Col>
                </Row>
                <Row className="py-30 markdown-menu">
                  <Col lg={12}>
                    {
                      detail.menuIncludedList.length > 0 ? (
                        <h5 className="text-tangaroa ft-16">¿Qué incluye?</h5>
                      ) : ''
                    }
                    {
                      detail.menuIncludedList.map((list) => {
                        return (
                          <div key={list.id} className="text-tangaroa">
                            {
                              detail.useRadioInMenuOptions
                                ? (
                                  <div className="custom-control custom-radio">
                                    <input
                                      id={`radio-type-${list.id}`}
                                      type="radio"
                                      name="radio-type"
                                      className="custom-control-input"
                                      onChange={(event) => setOptionValue(event.target.value)}
                                      value={list.id}
                                      checked={list.id === +optionValue} />
                                    <label className="custom-control-label text-tangaroa" htmlFor={`radio-type-${list.id}`}>
                                      {list.title}
                                    </label>
                                  </div>
                                ) : <p>{list.title}</p>
                            }
                            <div className="markdown-item text-tangaroa">
                              <ReactMarkdown>{list.items[0]}</ReactMarkdown>
                            </div>
                          </div>
                        );
                      })
                    }
                  </Col>
                </Row>
                <hr />
                <Row className="py-30" id="experience-info">
                  <Col lg={12}>
                    <h2 className="text-tangaroa ft-16">Lo que debes saber</h2>
                    {
                      detail.exclusivity === 'SANTANDER' ? (
                        <span className="exclusivity-span-santander text-tangaroa">Exclusivo Tarjetahabientes Santander</span>
                      ) : ''
                    }
                    {
                      detail.exclusivity === 'AMEX' ? (
                        <span className="exclusivity-span-amex text-tangaroa">Exclusivo Tarjetahabientes American Express® Aeroméxico</span>
                      ) : ''
                    }
                  </Col>
                  <Col lg={12}>
                    <div className="py-15 text-tangaroa">
                      <ReactMarkdown>{detail.youShoudKnow}</ReactMarkdown>
                    </div>
                  </Col>
                  {detail.endDate ? (
                    <Col lg={3}>
                      <i className="fas fa-calendar-alt mr-2 text-dove-gray" />
                      <small className="text-dove-gray">{`Vigencia: ${moment(detail.endDate).format('DD/MM/YYYY')}`}</small>
                    </Col>
                  ) : ''}
                  {detail.duration ? (
                    <Col lg={9}>
                      <i className="fas fa-clock mr-2 text-dove-gray" />
                      <small className="text-dove-gray">{`Duración de tu experiencia: ${detail.duration}`}</small>
                    </Col>
                  ) : ''}
                </Row>
              </Col>
              <Col lg={3} className={`mt-lg-60 order-lg-2 order-1 ${detail.stock === 0 && 'exhausted'}`}>
                {detail.type.constant === 'HOUSE' ? (
                  <TypeHome
                    details={detail}
                    points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
                    optionValue={optionValue}
                    setOptionValue={setOptionValue}
                    cards={cards} />
                ) : ''}
                {detail.type.constant === 'MASTERCLASS' ? (
                  <TypeFaceToFace
                    points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
                    details={detail}
                    optionValue={optionValue}
                    cards={cards} />
                ) : ''}
                {detail.type.constant === 'FACE_TO_FACE' ? (
                  <TypeFaceToFace
                    points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
                    details={detail}
                    optionValue={optionValue}
                    cards={cards} />
                ) : ''}
                {detail.type.constant === 'IN_PERSON_SCHEDULED' ? (
                  <TypeInPerson
                    points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
                    details={detail}
                    optionValue={optionValue}
                    setOptionValue={setOptionValue}
                    cards={cards} />
                ) : ''}
                {detail.type.constant === 'TRAVEL' ? (
                  <TypeTravel
                    points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
                    details={detail}
                    cards={cards} />
                ) : ''}
                {detail.type.constant === 'TRAVEL_INTERNATIONAL' ? (
                  <TypeTravel
                    points={detail.costWithDisscount > 0 ? detail.costWithDisscount : detail.cost}
                    details={detail}
                    cards={cards} />
                ) : ''}
              </Col>
            </Row>
          </Container>
        </Container>
        <Container fluid className="bg-white">
          <Row className="d-lg-none d-xl-none pb-60 px-15 bg-white">
            <Col xs={12}>
              <button type="button" className="btn btn-primary" onClick={handleOpenAddExperiencie}>
                Agregar al carrito
              </button>
            </Col>
          </Row>
        </Container>
        <ContactSection />
        <Container fluid className="bg-white">
          <Container>
            <Row className="justify-content-center py-60 accordion-terms">
              <Col lg={12}>
                <AccordionCollapse terms={detail.terms} />
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
    );
  };
  return (
    <div>
      {data.isFetching && isFetching && <LoaderCP />}
      {data.error && data.isFetching === false && isFetching === false && <NotFound />}
      {result && result.results && data.isFetching === false && isFetching === false
        && renderBody(result.results)}
    </div>
  );
};

export default DetailExperienceContainer;
